import { BarChart3 } from "lucide-react";

import { CcAdPerformanceDemo } from "@/components/home/growth-features/CcAdPerformanceDemo";
import type { SeoWorkflowAdPerformanceCardCopy } from "./seo-workflow-copy";
import { CcSeoWorkflowCard } from "./CcSeoWorkflowCard";

type CcSeoWorkflowAdPerformanceProps = {
  copy: SeoWorkflowAdPerformanceCardCopy;
};

export function CcSeoWorkflowAdPerformance({ copy }: CcSeoWorkflowAdPerformanceProps) {
  return (
    <CcSeoWorkflowCard
      id="ad-performance"
      title={copy.title}
      description={copy.description}
      badge={copy.badge}
      icon={BarChart3}
    >
      <CcAdPerformanceDemo copy={copy.demo} />
    </CcSeoWorkflowCard>
  );
}
